<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <!-- 60%居中毛玻璃主容器 -->
    <div class="nav">
      <!-- 模块标题 -->
      <div class="module-title">
        <h1>CT检查技术虚拟仿真系统</h1>
      </div>

      <!-- 主内容卡片 -->
      <div class="ct-content">
        <div class="desc-module">
          <p class="ct-desc">{{ p[0] }}</p>
        </div>
        <SImgNum :imgList="list" class="ct-img-list" />
      </div>

    </div>
  </div>
</template>

<script>
import SImgNum from "@/components/sImgNum.vue";
import PullDown from "@/components/home/pullDown.vue"

export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "CheckCT",
  components: {
    SImgNum,
    PullDown,
  },
  data() {
    return {
      p: [
        "以《医学影像检查技术学》为教学蓝本，CT检查技术虚拟仿真教学系统还原CT检查全流程，涵盖设备开机、工作前准备、检查前准备、CT室巡检、检查室准备、检查部位选择、摆位检查、检查后工作等关键环节，系统区分学习模式与考核模式，学习模式提供实时操作指导，考核模式支持自主命题、随机出题。针对高校实训设备紧缺、人均实操时长不足、辐射安全管控严格等教学难点，提供零风险、可反复训练的虚拟实训环境，持续规范学生扫描操作习惯，提升临床检查流程把控能力。",
      ],
      list: [
        { img: require("@/assets/cCT1.png"), text: "设备开机" },
        { img: require("@/assets/cCT2.png"), text: "工作前准备" },
        { img: require("@/assets/cCT3.png"), text: "检查前准备" },
        { img: require("@/assets/cCT4.png"), text: "检查室准备" },
        { img: require("@/assets/cCT5.png"), text: "检查部位选择" },
        { img: require("@/assets/cCT6.png"), text: "CT室巡检" },
        { img: require("@/assets/cCT7.png"), text: "摆位及检查" },
        { img: require("@/assets/cCT8.png"), text: "检查后工作" },
      ],
      wWidth: window.innerWidth,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  // 核心居中毛玻璃容器（与DeviceCT完全一致）
  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }

    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  // 统一标题样式
  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    h1 {
      margin: 0;
      font-size: inherit;
      font-weight: inherit;
    }

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  // 主内容白色卡片
  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
    }

    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
    }

    // 原有文字模块样式保留，适配内部布局
    .desc-module {
      position: relative;
      padding-left: 16px;
      margin-bottom: 44px;
      
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 4px;
        bottom: 4px;
        width: 4px;
        border-radius: 2px;
        background: linear-gradient(180deg, #5aa8ff, #1d6fe0);
      }
    }

    .ct-desc {
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 0.95rem;
      line-height: 1.9;
      color: #1e293b;
      margin: 0;
      text-align: justify;
      letter-spacing: 0.6px;
      word-break: break-all;

      @media (max-width: 767px) {
        font-size: 0.85rem;
        line-height: 1.8;
        letter-spacing: 0.3px;
      }
    }

    .ct-img-list {
      padding-top: 0;
    }
  }

  // 参考文献间距统一
  .refer-margin {
    margin-top: 2rem;
    padding: 0 2rem 2rem;

    @media (max-width: 767px) {
      margin-top: 1.5rem;
      padding: 0 1rem 1.5rem;
    }
  }
}

// 暗色模式完整适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .desc-module::before {
          background: linear-gradient(180deg, #63a8ff, #2574e0);
        }

        .ct-desc {
          color: #c8d6e8;
        }
      }
    }
  }
}

// 全局导航深度样式与CT设备页面保持一致
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>
